import React from "react";
import { getIn } from "formik";

export default class TextArea extends React.Component<any, any> {
  onBlur = (args: any) => {
    const { field, onBlur } = this.props;
    field.onBlur(args);

    if (onBlur) onBlur(args);
  };

  render() {
    const { className, field, form, ...props } = this.props;
    const { errors, touched } = form;
    const error = getIn(touched, field.name) && getIn(errors, field.name);

    return (
      <>
        <textarea
          id={field.name}
          className={`${className} ${error ? "red-border" : ""}`}
          {...field}
          {...props}
          onBlur={this.onBlur}
        />
        {error && <span className="text-danger">{error}</span>}
      </>
    );
  }
}
